/* eslint-disable react/prop-types */
import React from 'react';
import { Form } from 'react-bootstrap';
import classNames from 'classnames';
import dayjs from 'dayjs';
import InformationTooltip from '../ui/InformationTooltip';

const LabelDateInsert = ({
  controlId,
  required,
  label,
  labelProps,
  labelClass,
  formik,
  errorProps,
  information,
  minDate,
  maxDate,
  customValidate // optional custom validation function (value) => string | undefined
}) => {
  const handleChange = e => {
    formik.setFieldValue(controlId, e.target.value);
  };

  const handleBlur = () => {
    const value = formik.values[controlId];
    formik.setFieldTouched(controlId, true);

    const parsed = dayjs(value, 'YYYY-MM-DD', true);
    if (!parsed.isValid()) {
      formik.setFieldError(controlId, 'Invalid date format');
      return;
    }
    // minDate={dayjs().format('YYYY-MM-DD')}
    // maxDate={dayjs().format('YYYY-MM-DD')}
    // Apply minDate check if provided
    if (minDate && parsed.isBefore(dayjs(minDate))) {
      formik.setFieldError(
        controlId,
        `Date must be after ${dayjs(minDate).format('DD MMM YYYY')}`
      );
      return;
    }

    // Apply maxDate check if provided
    if (maxDate && parsed.isAfter(dayjs(maxDate))) {
      formik.setFieldError(
        controlId,
        `Date must be before ${dayjs(maxDate).format('DD MMM YYYY')}`
      );
      return;
    }

    // Apply any custom validation
    if (customValidate) {
      const error = customValidate(value);
      if (error) {
        formik.setFieldError(controlId, error);
      }
    }
  };

  return (
    <Form.Group controlId={controlId}>
      <Form.Label
        className={classNames(
          'd-block mb-1 fs-9 ps-1 text-capitalize fw-medium',
          { 'fw-bold': required },
          { 'd-flex flex-between-center': information },
          labelClass
        )}
        {...labelProps}
      >
        {label} {required && '*'}
        {information && (
          <InformationTooltip
            iconProp={{ className: 'fw-bold' }}
            label={information}
          />
        )}
      </Form.Label>

      <Form.Control
        type="date"
        name={controlId}
        value={formik.values[controlId] || ''}
        onChange={handleChange}
        onBlur={handleBlur}
        min={minDate}
        max={maxDate}
        className={classNames({
          'is-invalid': formik.touched[controlId] && formik.errors[controlId]
        })}
      />

      <Form.Control.Feedback type="invalid" {...errorProps}>
        {formik.errors[controlId]}
      </Form.Control.Feedback>
    </Form.Group>
  );
};

export default LabelDateInsert;
